{
  "name": "web-client",
  "version": "2.16.3",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "dev": "ng serve --configuration=development",
    "start:dev": "ng serve --configuration=development",
    "start:test": "ng serve --configuration=test",
    "build:test": "ng build  --configuration=test && pnpm sentry:sourcemaps",
    "build:prod": "ng build --configuration=production && pnpm sentry:sourcemaps",
    "build:test-localize": "ng build --configuration=test --localize=true && pnpm sentry:sourcemaps",
    "build:prod-localize": "ng build --configuration=production --localize=true && pnpm sentry:sourcemaps",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint",
    "format": "prettier --write \"src/**/*.{html,js,ts,scss}\" --log-level silent",
    "lint:format": "ng lint && prettier --write \"src/**/*.{html,js,ts,scss}\"",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org thrivable --project my-thrivable-app ./dist && sentry-cli sourcemaps upload --org thrivable --project my-thrivable-app ./dist",
    "e2e": "playwright test --config=e2e/playwright.config.ts",
    "e2e:ui": "playwright test --config=e2e/playwright.config.ts --ui",
    "e2e:account": "playwright test --config=e2e/playwright.config.ts --project=account",
    "e2e:admin": "playwright test --config=e2e/playwright.config.ts --project=admin",
    "e2e:researcher": "playwright test --config=e2e/playwright.config.ts --project=researcher",
    "e2e:member": "playwright test --config=e2e/playwright.config.ts --project=member --project=member-conditions --project=member-deactivation",
    "e2e:caregiver": "playwright test --config=e2e/playwright.config.ts --project=caregiver",
    "e2e:codegen": "playwright codegen https://test.thrivable.app/account/signin"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.15",
    "@angular/cdk": "21.2.14",
    "@angular/common": "21.2.17",
    "@angular/compiler": "21.2.17",
    "@angular/core": "21.2.17",
    "@angular/forms": "21.2.17",
    "@angular/platform-browser": "21.2.17",
    "@angular/platform-browser-dynamic": "21.2.15",
    "@angular/router": "21.2.17",
    "@fortawesome/fontawesome-pro": "7.3.0",
    "@ng-select/ng-select": "21.8.2",
    "@sentry/angular": "10.63.0",
    "@sentry/cli": "3.6.0",
    "@tailwindcss/postcss": "4.3.2",
    "@types/google-libphonenumber": "7.4.30",
    "aws-amplify": "6.18.0",
    "google-libphonenumber": "3.2.44",
    "ng-recaptcha": "13.2.1",
    "ngx-drag-drop": "21.0.6",
    "ngx-editor": "18.0.0",
    "ngx-spinner": "21.1.0",
    "rxjs": "7.8.2",
    "tslib": "2.8.1",
    "zone.js": "0.16.2"
  },
  "devDependencies": {
    "@angular-eslint/builder": "21.4.0",
    "@angular-eslint/eslint-plugin": "21.4.0",
    "@angular-eslint/eslint-plugin-template": "21.4.0",
    "@angular-eslint/schematics": "21.4.0",
    "@angular-eslint/template-parser": "21.4.0",
    "@angular/build": "21.2.18",
    "@angular/cli": "21.2.18",
    "@angular/compiler-cli": "21.2.17",
    "@angular/localize": "21.2.17",
    "@playwright/test": "^1.63.0",
    "@eslint/eslintrc": "^3.3.7",
    "@eslint/js": "^10.0.1",
    "@tailwindcss/typography": "0.5.20",
    "@types/jasmine": "6.0.0",
    "@typescript-eslint/eslint-plugin": "8.62.1",
    "@typescript-eslint/parser": "8.62.1",
    "autoprefixer": "10.5.2",
    "daisyui": "5.6.7",
    "dotenv": "^17.4.2",
    "eslint": "10.6.0",
    "eslint-config-prettier": "10.1.8",
    "jasmine-core": "6.3.0",
    "karma": "6.4.4",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage": "2.2.1",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.2.0",
    "postcss": "^8.5.3",
    "prettier": "3.9.4",
    "prettier-plugin-tailwindcss": "0.8.0",
    "tailwindcss": "4.3.2",
    "typescript": "6.0.2"
  },
  "pnpm": {
    "neverBuiltDependencies": []
  }
}
